import type { OrderStatus, ProductCategory } from './types';

export const VSS_STORE_SLUG = 'vss';

export const PRODUCT_CATEGORIES: ProductCategory[] = [
  'Virtual Staging',
  'ImageMotion',
  'HyperDusk',
  'PhotoClear',
  'HDRPhoto',
  '360 Tour Build',
  'Floor Plans',
  'CGI',
  'Credit Packs',
  'Subscriptions',
];

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  awaiting_payment: 'Awaiting payment',
  awaiting_files: 'Awaiting files',
  submitted: 'Submitted',
  in_progress: 'In progress',
  review: 'In review',
  completed: 'Completed',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
};

export const ORDER_STATUS_COLORS: Record<OrderStatus, string> = {
  awaiting_payment: 'bg-amber-900/40 text-amber-300',
  awaiting_files: 'bg-orange-900/40 text-orange-300',
  submitted: 'bg-blue-900/40 text-blue-300',
  in_progress: 'bg-indigo-900/40 text-indigo-300',
  review: 'bg-purple-900/40 text-purple-300',
  completed: 'bg-emerald-900/40 text-emerald-300',
  cancelled: 'bg-slate-800 text-slate-400',
  refunded: 'bg-rose-900/40 text-rose-300',
};

export function formatCashPrice(pence: number, currency = 'GBP'): string {
  const amount = pence / 100;
  return new Intl.NumberFormat(currency === 'GBP' ? 'en-GB' : 'en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: pence % 100 === 0 ? 0 : 2,
  }).format(amount);
}

export function getUsdPriceCents(product: {
  cash_price_pence: number;
  metadata: Record<string, unknown>;
}): number | null {
  const raw = product.metadata?.usd_price_cents;
  if (typeof raw === 'number' && raw > 0) return raw;
  return null;
}

export function formatDualCashPrice(product: {
  cash_price_pence: number;
  metadata: Record<string, unknown>;
}): { gbp: string; usd: string | null } {
  const usdCents = getUsdPriceCents(product);
  return {
    gbp: formatCashPrice(product.cash_price_pence, 'GBP'),
    usd: usdCents != null ? formatCashPrice(usdCents, 'USD') : null,
  };
}

export function canPayWithCredits(product: {
  credit_price: number | null;
  fulfilment_type: string;
}): boolean {
  return (
    product.credit_price != null &&
    product.credit_price > 0 &&
    product.fulfilment_type !== 'credits' &&
    product.fulfilment_type !== 'subscription'
  );
}

export function mustUseStripe(product: { fulfilment_type: string }): boolean {
  return product.fulfilment_type === 'credits' || product.fulfilment_type === 'subscription';
}
